/**
 * Constants and mappings for tooth SVG overlay manipulation
 */

import { CrackType, FractureType } from '../types/tooth.types'

/**
 * CSS class name constants for overlay elements
 */
export const OVERLAY_CLASSES = {
  CARIES_OVERLAY: '.caries-overlay',
  CARIES_SURFACE: '.caries-surface',
  RECURRING_CARIES_OVERLAY: '.recurring-caries-overlay',
  INLAY_OVERLAY: '.inlay-overlay',
  INLAY_SURFACE: '.inlay-surface',
  ONLAY_OVERLAY: '.onlay-overlay',
  EROSION_OVERLAY: '.erosion-overlay',
  EROSION_BUCAL: '.erosion-buccal',
  EROSION_PALATAL: '.erosion-palatal',
  EROSION_LINGUAL: '.erosion-lingual',
  EROSION_BUCAL_OVERLAY: '.erosion-buccal-overlay',
  EROSION_PALATAL_OVERLAY: '.erosion-palatal-overlay',
  EROSION_LINGUAL_OVERLAY: '.erosion-lingual-overlay',
  CROWN_OVERLAY: '.crown-overlay',
  VENEER_OVERLAY: '.veneer-overlay',
  PONTIC_OVERLAY: '.pontic-overlay',
  PONTIC_TYPE: '.pontic-type',
  SEALANT_OVERLAY: '.sealant-overlay',
  MISSING_OVERLAY: '.missing-overlay',
  IMPLANT_OVERLAY: '.implant-overlay',
  FURCATION_OVERLAY: '.furcation-overlay',
  FURCATION_LEVEL: '.furcation-level',
  FILLING_OVERLAY: '.filling-overlay',
  FILLING_SURFACE: '.filling-surface',
  APICOETOMY_OVERLAY: '.apicoetomy-overlay',
  PERIAPICAL_OVERLAY: '.periapical-overlay',
  ROOT_CANAL_OVERLAY: '.root-canal-overlay',
  PULPOTOMY_OVERLAY: '.partial-pulpotomy-overlay',
  PULPECTOMY_OVERLAY: '.pulpectomy-overlay',
  PERIRADICULAR_OVERLAY: '.periradicular-overlay',
  IMPACTED_OVERLAY: '.impacted-overlay',
  DRIFTED_OVERLAY: '.drifted-overlay',
  SUPERNUMERARY_OVERLAY: '.supernumerary-overlay',
  SINUS_TRACT_OVERLAY: '.sinus-tract-overlay',
  RETAINED_PRIMARY_OVERLAY: '.retained-primary-overlay',
  RECESSION_OVERLAY: '.recession-overlay',
  ATTRITION_OVERLAY: '.attrition-overlay',
  ABRASION_OVERLAY: '.abrasion-overlay',
  CRACK_OVERLAY: '.crack-overlay',
  CRACK_AREA: '.crack-area',
  FRACTURE_OVERLAY: '.fracture-overlay',
  FRACTURE_AREA: '.fracture-area',
} as const

/**
 * Crown material class names
 */
export const CROWN_CLASSES = [
  '.crown-zirconia',
  '.crown-pfm',
  '.crown-pfz',
  '.crown-metal',
  '.crown-ceramic',
] as const

/**
 * Mapping from FractureType to CSS class names
 */
export const FRACTURE_CLASS_MAP: Record<FractureType, string> = {
  distobuccal: 'disto_buccal',
  mesiobuccal: 'mesio_buccal',
  distopalatal: 'disto_palatal',
  mesiopalatal: 'mesio_palatal',
  distolingual: 'disto_lingual',
  mesiolingual: 'mesio_lingual',
  incisal: 'incisal',
  difl: 'difl',
  difp: 'difp',
  mifl: 'mifl',
  mifp: 'mifp',
  vertical_root: 'root_vertical',
  horizontal_root: 'root_horizontal',
} as const

export const CRACK_CLASS_MAP: Record<CrackType, string> = {
  vertical_crown_buccal: 'crown_vertical',
  vertical_crown_lingual: 'crown_vertical',
  vertical_crown_palatal: 'crown_vertical',
  vertical_crown_occlusal: 'occlusal_vertical',
  horizontal_crown_buccal: 'crown_horizontal',
  horizontal_crown_lingual: 'crown_horizontal',
  horizontal_crown_palatal: 'crown_horizontal',
  horizontal_crown_occlusal: 'occlusal_horizontal',
} as const

/**
 * Inlay surface class name mapping
 */
export const INLAY_SURFACE_MAP: Record<string, string> = {
  mesial: 'inlay-mesial',
  distal: 'inlay-distal',
  occlusal: 'inlay-occlusal',
} as const

/**
 * Display values
 */
export const DISPLAY = {
  BLOCK: 'block',
  NONE: 'none',
} as const
